import React from "react";
import { Check, Loader2, AlertCircle, Circle } from "lucide-react";

function relTime(d) {
  if (!d) return "";
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 5) return "just now";
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export default function AutoSaveIndicator({ status, lastSavedAt }) {
  let content;
  if (status === "saving") {
    content = <><Loader2 size={12} className="animate-spin" /> Saving…</>;
  } else if (status === "saved") {
    content = <><Check size={12} className="text-emerald-600" /> Saved {relTime(lastSavedAt)}</>;
  } else if (status === "error") {
    content = <><AlertCircle size={12} className="text-rose-600" /> Save failed — retrying</>;
  } else {
    content = <><Circle size={8} className="text-ink-muted" /> Auto-save on</>;
  }
  return (
    <div
      className="inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-widest text-ink-muted"
      data-testid="autosave-indicator"
      data-status={status}
    >
      {content}
    </div>
  );
}
